import React from "react"
import moment from "moment"

const IntervalTable = ({ intervals, onClick }) => {
  if (!intervals) return <div></div>
  return (
    <table className="responsive-table bordered highlight centered">
      <thead>
        <tr>
          <th id={'i-field'}>Field</th>
          <th id={'i-r1Start'}>R1 Start</th>
          <th id={'i-r1End'}>R1 End</th>
          <th id={'i-r1Acres'}>R1 Acres</th>
          <th id={'i-r1Percent'}>R1 %</th>
          <th id={'i-r1Interval'} className="blue-text">Interval</th>
          <th id={'i-r2Start'}>R2 Start</th>
          <th id={'i-r2End'}>R2 End</th>
          <th id={'i-r2Acres'}>R2 Acres</th>
          <th id={'i-r2Percent'}>R2 %</th>
          <th id={'i-r2Interval'} className="blue-text">Interval</th>
          <th id={'i-r3Start'}>R3 Start</th>
          <th id={'i-r3End'}>R3 End</th>
          <th id={'i-r3Acres'}>R3 Acres</th>
          <th id={'i-r3Percent'}>R3 %</th>
          <th id={'i-r3Interval'} className="blue-text">Interval</th>
        </tr>
      </thead>
      <tbody>
        { 
          intervals.map((e,i) => {
            return (
              <tr key={e.field}>
                <td>{ e.field }</td>
                <td>{ moment(e.r1Start).format('YYYY-MM-DD') }</td>
                <td>{ moment(e.r1End).format('YYYY-MM-DD') }</td>
                <td>{ e.r1Acres }</td>
                <td>{ `${e.r1Percent}%` }</td>
                <td><b>{ e.r1Interval }</b></td>
                <td>{ e.r2Start ? moment(e.r2Start).format('YYYY-MM-DD') : '' }</td>
                <td>{ e.r2End ? moment(e.r2End).format('YYYY-MM-DD') : '' }</td>
                <td>{ e.r2Acres }</td>
                <td>{ e.r2Percent ? `${e.r2Percent}%` : '' }</td>
                <td><b>{ e.r2Interval }</b></td>
                <td>{ e.r3Start ? moment(e.r3Start).format('YYYY-MM-DD') : '' }</td>
                <td>{ e.r3End ? moment(e.r3End).format('YYYY-MM-DD') : '' }</td>
                <td>{ e.r3Acres }</td>
                <td>{ e.r3Percent ? `${e.r3Percent}%` : '' }</td>
                <td><b>{ e.r3Interval }</b></td>
              </tr>
            )
          })
        }
      </tbody>
      <tfoot className="hide-on-med-and-down">
        <tr>
          
        </tr>
      </tfoot>
    </table>
  )
}

export default IntervalTable


// WEBPACK FOOTER //
// ./src/interval/components/interval_table.jsx